import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const SectionTitle = styled(Typography, {
  name: 'SectionTitle',
  slot: 'Root',
  skipSx: true,
  shouldForwardProp: (prop) => prop !== 'marginTop' && prop != 'marginBottom',
})(
  ({ marginBottom, marginTop }) =>
    `
  font-family: Source Sans Pro Semibold;
  font-size: 16px;
  margin-bottom: ${marginBottom ? `${marginBottom}` : '12px'};
  margin-top: ${marginTop ? `${marginTop}` : '0px'};
`,
)
